export default "__VITE_ASSET__ChziGvmD__"